import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {Entity} from '../classes/entity';

@Injectable({
    providedIn: 'root'
})
export class EntityService {

    constructor(private apiService: ApiService) {
    }

    saveEntity(entity: Entity) {
        return this.apiService.postCall$<Entity>(`entities`, entity);
    }

    saveEntities(entities: Entity[]) {

        return this.apiService.postCall$<Entity[]>(`entities/multi`, entities);
    }

    getEntity(id: number) {
        return this.apiService.getCall$<Entity>(`entities/${id}`);
    }

    getForTtm(ttmId: number) {
        return this.apiService.getCall$<Entity[]>(`entities/for-ttm/${ttmId}`);
    }

}
